<template>
  <div>
    <p class="title">{{title}}</p>
    <div>
      <seletor
        :elements="elements"
        :selected.sync="selectedMutable"
      ></seletor>
    </div>
  </div>
</template>
<script>

import Seletor from '../../seletor/Seletor'

export default {
  name: 'FilterComponentExemple',
  props: {
    title: {
      type: String,
      default: ''
    },
    elements: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Seletor
  },
  data () {
    return {
      selectedMutable: [...this.selected]
    }
  },
  watch: {
    selected (newVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(this.selectedMutable)) {
        this.selectedMutable = [...newVal]
      }
    },
    selectedMutable (newVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(this.selected)) {
        this.$emit('update:selected', newVal)
      }
    }
  }
}
</script>
